// extracted by mini-css-extract-plugin
export var pillWrapper = "_ph-0";
export var showOverflow = "_ph-1";